export default "__VITE_ASSET__DrpUsmIg__"